import React from 'react'

import { Box } from '../components/system'

const ImagePlaceholder = ({ bg, aspectRatio, ...props }) => (
  <Box
    {...props}
    bg={bg || 'grey.100'}
    height={0}
    mb={4}
    pb={aspectRatio ? `${aspectRatio * 100}%` : `${(9 / 16) * 100}%`}
    width="100%"
  />
)

export default ImagePlaceholder
